export default __webpack_public_path__ + "static/media/calendar.bbd60ccf.svg";